var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contract-form" }, [
    _c(
      "div",
      { staticClass: "addContend" },
      [
        _c(
          "el-card",
          {
            staticClass: "mb10",
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", { staticClass: "card-header" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.UnderlyingData"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c("BasicForm", {
              ref: "basicForm",
              attrs: { "form-data": _vm.params, type: _vm.type },
            }),
          ],
          1
        ),
        _c(
          "el-card",
          {
            staticClass: "mb10",
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", { staticClass: "card-header" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.BusinessInformation"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            !_vm.params.businessList.length
              ? _c(
                  "div",
                  { staticClass: "add", on: { click: _vm.addBusiness } },
                  [
                    _c("i", { staticClass: "el-icon-folder-add" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("basicData.ClickHereToAddBusinessInformation")
                        )
                    ),
                  ]
                )
              : _c("BasicTable", {
                  ref: "basicTable",
                  attrs: { "table-data": _vm.params.businessList },
                }),
          ],
          1
        ),
        _c(
          "el-card",
          {
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", { staticClass: "card-header" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.ScannedDocuments"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            !_vm.params.fileList.length
              ? _c(
                  "div",
                  { staticClass: "el-upload" },
                  [
                    _c("UploadCmp", {
                      attrs: {
                        drag: true,
                        "auto-upload": true,
                        "show-file-list": false,
                        "is-check-file-type": true,
                        "file-size": 50,
                        limit: 1,
                        "upload-text": _vm.$t("basicData.SupportedFileFormats"),
                      },
                      on: { change: _vm.onFileChange },
                    }),
                  ],
                  1
                )
              : _c("ScanTable", {
                  ref: "scanTable",
                  attrs: {
                    id: _vm.params.id,
                    "table-data": _vm.params.fileList,
                  },
                  on: { close: _vm.cancel },
                }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "addFooter" },
      [
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.cancel } },
          [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "permit",
                rawName: "v-permit:remove",
                value: "btn:basicData:contractLedger:edit",
                expression: "'btn:basicData:contractLedger:edit'",
                arg: "remove",
              },
            ],
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.submitForm },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }